const langPackLocalVersion = 10;export default langPackLocalVersion;
